import React, { useState, useEffect } from "react";
import axios from "axios";
import "./dummy.css";
import { ConfigCells } from "./ConfigCells";

export const BatteryCells = ({ cellsData, setCellsData, num_cols, isConfig, cellImage, totalCells }) => {
  const [cells, setCells] = useState([]);
  const [modules, setModules] = useState({});

  useEffect(() => {
    const fetchCellsData = async () => {
      try {
        const response = await axios.post(`${process.env.BACKEND_URL}batteries/random_cells`, {
          total_cells: totalCells,
          rows: Math.ceil(totalCells / num_cols),
          columns: num_cols
        });
        const cells = response.data;
        const modulesData = {};
        cells.forEach((cell, index) => {
          const colIndex = index % num_cols + 1; // Column index starts from 1
          if (!modulesData[`module${colIndex}`]) {
            modulesData[`module${colIndex}`] = [];
          }
          modulesData[`module${colIndex}`].push(cell);
        });
        setModules(modulesData);
        setCells(response.data);
        setCellsData(response.data);
      } catch (error) {
        console.error("Error fetching cells data:", error);
      }
    };

    fetchCellsData();
  }, [totalCells, num_cols]);

  return (
    <div id="btryConfig" className="flex flex-col justify-center items-center w-full">
      <div className="flex flex-row justify-between min-w-[90%] ">
        <div className="col-auto mr-auto cellEndCol1 w-8 max-xsm:w-4 text-[#000]">
          <h3>+</h3>
        </div>
        <div className="col-auto ml-auto cellEndCol2 w-8 max-xsm:w-4 text-[#000]">
          <h2>-</h2>
        </div>
      </div>
      <div className="col-sm-auto fixed_window bg-[black]">
        <div
          className="grid-container grid"
          style={{
            gridTemplateColumns: `repeat(${num_cols.toString()}, 1fr)`,
            ...(isConfig ? {} : { gridTemplateRows: `30px repeat(auto-fill, minmax(30px, auto))` })
        }}
          > 
          {[...Array(num_cols)].map((_, index) => (
            <div key={`module-${index}`}>
            {!isConfig &&
            <div key={`header-${index}`} className="col-header">
              Module {index + 1}
            </div>}
            </div>
          ))}
          {cells.map((cell, index) => (
            <ConfigCells
              key={index}
              isConfig={isConfig}
              cellImage={cellImage}
              row={Math.floor(index / num_cols)}
              col={index % num_cols}
              numCols={num_cols}
              numRows={Math.ceil(totalCells / num_cols)}
              soh={cell.meta.soh}
              cellId={cell._id}
            />
          ))}
        </div>
      </div>
    </div>
  );
};
